/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ScheduleItem } from '../../models/schedule-item';

export interface ScheduleControllerFindOneSchedule$Params {
  id: number;
}

export function scheduleControllerFindOneSchedule(http: HttpClient, rootUrl: string, params: ScheduleControllerFindOneSchedule$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ScheduleItem;
}>> {
  const rb = new RequestBuilder(rootUrl, scheduleControllerFindOneSchedule.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: ScheduleItem;
      }>;
    })
  );
}

scheduleControllerFindOneSchedule.PATH = '/schedule/{id}';
